<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="businessPersonAudits && businessPersonAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list [audits]="businessPersonAudits" (nextPage)="onNextPage()">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Employer audits </ng-template>
</ng-template>
